export function getAsList (supplements)
{
	const rows = [];

	supplements.forEach(group =>
	{
		const parts = [];

		group.items.forEach(item =>
		{
			parts.push(item.item.label);
		})

		rows.push(parts.join(', '));
	});

	return rows.join(' | ');
}